import { render, staticRenderFns } from "./CarCategoriesOverview.vue?vue&type=template&id=848c0298&scoped=true&"
import script from "./CarCategoriesOverview.vue?vue&type=script&lang=js&"
export * from "./CarCategoriesOverview.vue?vue&type=script&lang=js&"
import style0 from "./CarCategoriesOverview.vue?vue&type=style&index=0&id=848c0298&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848c0298",
  null
  
)

export default component.exports